<div class="info-container">
  <span class="small-snack-text">
    {{ data.message }}
  </span>
  <span class="icon-right">
    <mat-icon>info</mat-icon>
  </span>
</div>
